import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  public loaderEvent = new EventEmitter<boolean>();
  constructor() {}

  load() {
    this.loaderEvent.emit(true);
  }
  stop() {
    this.loaderEvent.emit(false);
  }
}
